import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { SEO } from "../data/seo";

export const NotFoundPage = () => (
  <div className="min-h-[80vh] flex items-center justify-center text-center px-6" data-testid="not-found-page">
    <Seo title={SEO.notFound.title} description={SEO.notFound.description} noindex />
    <div>
      <div className="font-serif text-[14vw] md:text-[10vw] text-gold/20 leading-none">404</div>
      <h1 className="heading-display text-4xl md:text-5xl mt-6">This page got <span className="italic text-gold">lost.</span></h1>
      <p className="text-ink/60 mt-4 max-w-md mx-auto">The page you're looking for doesn't exist. Let's get you back home.</p>
      <Link to="/" data-testid="not-found-home-link" className="btn-primary mt-10 inline-flex">Return Home</Link>
    </div>
  </div>
);
